export default (value?: string|number, decimal:number=12,empty:string='--') => {
    if(value!==0 && !value){
        return empty || ''
    }
    const str=value+'';
    if(str.length>=decimal){
        return str
    }
    return "0".repeat(decimal-str.length)+str
}
